<template>
  <div class="controls-wrap table-responsive">
    <!-- Integration Field -->
    <div class="jobs-controls m-3">
      <h6 v-if="header" class="d-flex align-items-center">Documents</h6>

      <CustomMainModal @close="showModal = false" v-show="showModal">
        <template v-slot:header>
          <h5>Add Document</h5>
        </template>

        <section>
          <div class="row justify-content-center">
            <div class="col-md-11 mt-4">
              <Message v-show="errorMessage" class="mt-2" type="error-alert">
                <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
              </Message>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-11">
              <form ref="fileForm" key="fileForm">
                <div class="dropzone p-4">
                  <div class="dropzone-message file-drag-drop">
                    <p class="small drop-files">
                      Upload document here or click to browse for file.
                    </p>

                    <label
                      for="candidate-files"
                      class="btn btn-primary btn-sm file-upload-label mb-0"
                      >Browse</label
                    >

                    <input
                      type="file"
                      id="candidate-files"
                      ref="candidateDocumentsFiles"
                      name="candidateDocumentsFiles"
                      @input="handleCandidateDocumentsFileUpload"
                      class="file-upload-input"
                      accept=".doc,.docx,.pdf,.odt"
                      multiple
                    />

                    <ul class="list-group file-listing mt-3">
                      <li
                        v-for="(file, key) in candidateDocumentsFiles"
                        :key="key"
                        class="list-group-item d-flex align-items-center small"
                      >
                        <span class="mr-3">
                          <i
                            ref="primaryIcon"
                            :title="
                              itemId == key ? 'Select as primary CV' : 'Deselect as primary CV'
                            "
                            @click="setAsDefault($event)"
                            :id="key"
                            :class="['fas fa-crown', itemId == key ? 'crown-active' : '']"
                          ></i>
                        </span>

                        <span class="mr-auto">{{ file.name }}</span>
                        <span class="badge badge-primary badge-pill ml-auto">{{
                          `${(file.size / 1024 / 1024).toFixed(2)} MB`
                        }}</span>
                        <span class="remove-container ml-4">
                          <span class="close" style="cursor: pointer" @click="removeFile(key)"
                            >&times;</span
                          >
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row justify-content-center mb-5">
            <div class="col-md-5">
              <div class="text-center mt-3 d-flex">
                <button
                  @click="submitFiles"
                  :disabled="candidateDocumentsFiles.length <= 0"
                  class="btn btn-secondary btn-custom w-50 mr-4"
                >
                  Upload
                </button>
                <button class="btn btn-primary btn-custom w-50" @click="cancelUpload">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </section>
      </CustomMainModal>
    </div>
    <div v-if="header" class="content">
      <table
        v-show="getManagerCandidateDocuments.length > 0"
        class="table table-striped custom-table table-responsive"
      >
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col" style="width: 45%; font-weight: 600">DOCUMENT NAME</th>
            <th nowrap scope="col" style="font-weight: 600">DATE</th>
            <th
              class="hide-on-mobile"
              nowrap
              scope="col"
              style="font-weight: 600; text-align: right"
            >
              ACTIONS
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="document in getManagerCandidateDocuments" :key="document.id">
            <td id="document-name">
              <div class="d-flex" v-if="document.name.split('.').pop() === 'pdf'">
                <i
                  @click="openDocPreview(document.id, document.name)"
                  :class="[`mr-3 fa`, document.icon]"
                  :style="`cursor: pointer; color: ${getIconColor(document.name)}; font-size: 22px`"
                ></i>

                <router-link to>
                  <span @click="openDocPreview(document.id, document.name)">{{
                    document.name
                  }}</span></router-link
                >
              </div>
              <div class="d-flex" v-else>
                <i
                  @click="onDownloadDocumentNoFlag(document.id, document.name)"
                  :class="[`mr-3 fa`, document.icon]"
                  :style="`cursor: pointer; color: ${getIconColor(document.name)}; font-size: 22px`"
                ></i>

                <router-link to>
                  <span @click="onDownloadDocumentNoFlag(document.id, document.name)">{{
                    document.name
                  }}</span></router-link
                >
              </div>
            </td>
            <td nowrap>
              <popper
                trigger="hover"
                :options="{
                  placement: 'left',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">
                  {{
                    document.created_at
                      | formatDate({
                        format: getManagerUserProfile.format_date,
                        timezone: getManagerUserProfile.timezone,
                        hasHourAndMinutes: true,
                      })
                  }}
                </div>
                <div slot="reference">
                  {{
                    document.created_at
                      | formatDate({
                        format: getManagerUserProfile.format_date,
                        timezone: getManagerUserProfile.timezone,
                        hasHourAndMinutes: false,
                      })
                  }}
                </div>
              </popper>
            </td>
            <td class="hide-on-mobile" id="documents-actions">
              <div class="icon-wrapper d-flex justify-content-between">
                <svgHelper
                  @click.native="openDocPreview(document.id, document.name)"
                  class="mr-3"
                  name="view"
                ></svgHelper>
                <svgHelper
                  v-if="document.name.split('.').pop() === 'pdf'"
                  @click.native="onDownloadDocument(document.id, document.name)"
                  class="mr-3 download-arrow"
                  name="download"
                ></svgHelper>
                <svgHelper
                  v-else
                  @click.native="onDownloadDocumentNoFlag(document.id, document.name)"
                  class="mr-3 download-arrow"
                  name="download"
                ></svgHelper>
                <!--     <a data-toggle="modal" href="#deleteModal" @click="setDeleteDocument(document)">
                  <svgHelper name="delete"></svgHelper>
                </a> -->
              </div>
              <!-- Delete Modal -->
              <div
                class="modal fade edit-modal"
                id="deleteModal"
                tabindex="-1"
                aria-labelledby="deleteModal"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="editModal2Label">Delete File</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body text-center justify-content-center">
                      <p>Please confirm that you want to delete {{ document.name }}</p>
                    </div>
                    <div class="modal-footer text-center justify-content-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click="onDeleteDocument(document)"
                      >
                        Delete
                      </button>

                      <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Delete Modal -->
            </td>
          </tr>
        </tbody>
      </table>

      <ErrorList
        class="no-data-message"
        v-show="getManagerCandidateDocuments.length == 0"
        name="noDocuments"
      />

      <Spinner :isLoading="isLoading" />

      <Spinner :isLoading="isCvLoading" />
    </div>

    <div v-else class="content" style="overflow-y:auto">
      <ul v-show="getManagerCandidateDocuments.length > 0" class="list-unstyled">
        <li v-for="document in getManagerCandidateDocuments" :key="document.id">
          <div class="d-flex" v-if="document.name.split('.').pop() === 'pdf'">
            <div>
              <i
                @click="openDocPreview(document.id, document.name)"
                :class="[`mr-2 fa`, document.icon]"
                :style="`cursor: pointer; color: ${getIconColor(document.name)}; font-size: 22px`"
              ></i>

              <router-link to>
                <span @click="openDocPreview(document.id, document.name)">{{
                  document.name
                }}</span></router-link
              >
            </div>
            <popper
              trigger="hover"
              :options="{
                placement: 'left',
                modifiers: { offset: { offset: '0,10px' } },
              }"
            >
              <div class="popper">
                {{
                  document.created_at
                    | formatDate({
                      format: getManagerUserProfile.format_date,
                      timezone: getManagerUserProfile.timezone,
                      hasHourAndMinutes: true,
                    })
                }}
              </div>
              <div slot="reference">
                {{
                  document.created_at
                    | formatDate({
                      format: getManagerUserProfile.format_date,
                      timezone: getManagerUserProfile.timezone,
                      hasHourAndMinutes: false,
                    })
                }}
              </div>
            </popper>
          </div>
          <div class="d-flex" v-else>
            <div>
              <i
                @click="onDownloadDocumentNoFlag(document.id, document.name)"
                :class="[`mr-3 fa`, document.icon]"
                :style="`cursor: pointer; color: ${getIconColor(document.name)}; font-size: 22px`"
              ></i>

              <router-link to>
                <span @click="onDownloadDocumentNoFlag(document.id, document.name)">{{
                  document.name
                }}</span></router-link
              >
            </div>

            <popper
              trigger="hover"
              :options="{
                placement: 'left',
                modifiers: { offset: { offset: '0,10px' } },
              }"
            >
              <div class="popper">
                {{
                  document.created_at
                    | formatDate({
                      format: getManagerUserProfile.format_date,
                      timezone: getManagerUserProfile.timezone,
                      hasHourAndMinutes: true,
                    })
                }}
              </div>
              <div slot="reference">
                {{
                  document.created_at
                    | formatDate({
                      format: getManagerUserProfile.format_date,
                      timezone: getManagerUserProfile.timezone,
                      hasHourAndMinutes: false,
                    })
                }}
              </div>
            </popper>
          </div>
        </li>
      </ul>
      <ErrorList
        class="no-data-message"
        v-show="getManagerCandidateDocuments.length == 0"
        name="noDocuments"
      />
      <Spinner :isLoading="isLoading" />

      <Spinner :isLoading="isCvLoading" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* import Pagination from '@/components/Navigations/Pagination'; */
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Message from '../../AlertMessages/Message';
import ErrorList from '@/components/common/errorsList';

/* import { selectDefaultDocument } from '../../../mixins/selectDefaultDocumentMixin'; */
import { errorService } from '../../../services/errorService';

import axios from 'axios';

// import moment from 'moment-timezone';

const MAX_FILE_SIZE = 20;

export default {
  props: {
    header: Boolean,
  },
  components: { CustomMainModal, Message, ErrorList },
  /*  mixins: [selectDefaultDocument], */
  data: () => ({
    itemId: null,
    isLoading: false,
    isCvLoading: false,
    showModal: false,
    isPrimary: false,
    files: [],
    file: '',
    candidateDocumentsFiles: [],
    errorMessage: '',
    isUploading: false,
    documentToDelete: '',
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerCandidateDocumentPreview']),
    getIconColor(fileName) {
      const re = /(?:\.([^.]+))?$/;
      if (re.exec(fileName)[1] === 'pdf') {
        return '#ff0000';
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return '#005a9e';
      } else {
        return '#a7a7a77';
      }
    },
    setDeleteDocument(doc) {
      this.documentToDelete = doc;
    },
    onDeleteDocument(doc) {
      this.deleteDocument({ uuid: doc.id }).then(() => {
        this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });
      });
    },
    setAsDefault(e) {
      this.isLoading = true;

      this.setDefaultDocument({ uuid: e.target.id })
        .then(() => {
          this.isLoading = false;
          this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });
        })
        .catch(() => (this.isLoading = false));
    },
    handleCandidateDocumentsFileUpload() {
      /* console.log(
        'handleCandidateDocumentsFileUpload: ',
        this.$refs['candidateDocumentsFiles'].files,
      ); */

      const uploadedFiles = this.$refs['candidateDocumentsFiles'].files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.candidateDocumentsFiles.push(uploadedFiles[i]);
      }

      this.$refs.fileForm.reset();

      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of 20 MB.`;
        }
      }
    },
    submitFiles() {
      this.isUploading = true;

      const formData = new FormData();
      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        } else {
          this.$refs.primaryIcon[i].classList.contains('crown-active')
            ? (this.isPrimary = true)
            : (this.isPrimary = false);

          formData.append(`file_${i}`, file);
          formData.append(`primary_${i}`, this.isPrimary);
        }
      }

      formData.append('files_count', this.candidateDocumentsFiles.length);
      formData.append('js_candidate_id', this.$route.params.candidate_id);

      if (this.candidateDocumentsFiles.length) {
        axios
          .post(`${process.env.VUE_APP_API_URL}/admin/candidatedocuments/upload`, formData, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total),
              );
            },
          })
          .then(() => {
            this.isUploading = false;
            this.uploadPercentage = 0;
            this.errorMessage = '';

            this.retrieveCandidateById({ uuid: this.$route.params.candidate_id });

            this.showModal = false;
          })
          .catch(err => {
            this.$toasted.error(`${err}`, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });

            this.isUploading = false;
            this.uploadPercentage = 0;
          });
      }
    },
    closeModal() {
      this.errorMessage = '';
      this.candidateDocumentsFiles = [];
      this.showModal = false;
    },
    removeFile(key) {
      this.candidateDocumentsFiles.splice(key, 1);
    },
    cancelUpload() {
      this.candidateDocumentsFiles = [];
      this.showModal = false;
    },
    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
    onDownloadDocument(docId, docTitle) {
      this.retrieveManagerCandidateDocumentPreview({ uuid: docId, preview: false })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          fileLink.setAttribute('target', '_blank');
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    onDownloadDocumentNoFlag(docId, docTitle) {
      this.retrieveManagerCandidateDocumentPreview({ uuid: docId })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          fileLink.setAttribute('target', '_blank');
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    openDocPreview(docId, name) {
      const fileExtension = name
        .split('.')
        .pop()
        .toLowerCase();
      const imageFileTypes = ['jpg', 'jpeg', 'png', 'heic'];
      if (imageFileTypes.includes(fileExtension)) {
        this.retrieveManagerCandidateDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            let mimeType;
            switch (fileExtension) {
              case 'png':
                mimeType = 'image/png';
                break;
              case 'heic':
                mimeType = 'image/heic';
                break;
              default:
                mimeType = 'image/jpeg';
            }

            const blob = new window.Blob([response.data], { type: mimeType });
            const fileURL = window.URL.createObjectURL(blob);

            // Open the image in a new tab
            const newWindow = window.open('', '_blank');
            newWindow.document.write(`
          <html>
            <head>
              <title>Image Preview</title>
            </head>
            <body style="margin:0;">
              <img src="${fileURL}" style="width:100%; height:100%; object-fit:contain;" />
            </body>
          </html>
        `);
            newWindow.document.close();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      } else {
        this.isCvLoading = true;
        this.retrieveManagerCandidateDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            this.isCvLoading = false;
            const blob = new window.Blob([response.data], { type: 'application/pdf' });

            const fileURL = window.URL.createObjectURL(blob);

            window.open(fileURL, '_blank').focus();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      }
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerCandidateDocuments', 'getManagerUserProfile']),
  },
  mounted() {
    console.log(this.header);
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    this.$nextTick(() => {
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(
          event => {
            this.$refs.fileForm.addEventListener(
              event,
              e => {
                e.preventDefault();
                e.stopPropagation();
              },
              false,
            );
          },
        );

        this.$refs.fileForm.addEventListener('drop', e => {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push(e.dataTransfer.files[i]);
          }
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins';

/* Default select doc icon */
@include select-default-document-icon-styles;
@include orange-scrollbar;

.controls-wrap {
  overflow: hidden;
  h6 {
    font-size: 18px;
    font-weight: 700;
    margin-block: 8px;
  }
  .table-responsive {
    display: table !important;
  }
}
.content {
  position: relative;
  height: 349px;
}

.input-group {
  position: relative;
  i {
    position: absolute;
    pointer-events: none;
    top: 8px;
    right: 12px;
    z-index: 999;
    color: $color-table-location;
    font-size: 21px;
  }
  .form-control {
    border-radius: 0.25rem !important;
  }
}

.svg-icon:hover {
  cursor: pointer;
}

.icon-wrapper {
  svg {
    width: 16px;
    height: 18px;
  }
}

.controls-wrap .custom-table i {
  color: #a7a7a7;
  font-size: 16px;
}

.list-unstyled {
  li {
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    .d-flex {
      justify-content: space-between;
      align-items: center;
    }
  }
}

@media only screen and (max-width: 576px) {
  .hide-on-mobile {
    display: none !important;
  }
}
</style>
